import React, { Component } from "react"

import { graphql } from '@apollo/client/react/hoc'
import { Container } from "reactstrap"
import InsuranceListHeader from "./InsuranceListHeader"
import InsuranceList from "./InsuranceList"
import ListingTabs from "../Material/ListingTabs"
import ReportsPanel from "../Reports/ReportsPanel"
import { ROUTES } from "../Layout/routes"
import { withPathTab } from "../Functions/usePathTab"

import withApolloClient from '../withApolloClient'

const PENDING_STATUSES = [3, 6] // Pending, Needs Manual Review
export const INSURANCE_LISTING_TABS = [
    { id: "commercial", name: "Pending - Commercial", filters: { statuses: PENDING_STATUSES, hasMissingDocs: true, orderBy: ["-driver__in_office", "-date_modified"] } },
    { id: "uw", name: "Pending - UW", filters: { statuses: PENDING_STATUSES, hasMissingDocs: false, orderBy: ["-driver__in_office", "-date_modified"] } },
    { id: "active", name: "Active", filters: { statuses: 1, orderBy: ["-driver__in_office", "-date_added"] } },
    { id: "all", name: "All Insurances", filters: { orderBy: ["-driver__in_office", "-date_added"] } },
    { id: "reports", name: "Activity Log", iconClassName: "fa fa-history", floatRight: true, iconOnly: true, filters: { orderBy: ["-driver__in_office", "-date_added"] } },
]

// Note: If you are chaging any ID in the tableheader make sure to match that id in the listing page as well.
const tableHeaders = [
    { id: "date_added", name: "Date Added", sortable: true, view: ["Active", "All Insurances"], preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "date_modified", name: "Date Modified", sortable: true, view: ["Pending - Commercial", "Pending - UW"], preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "driver__last_name", name: "Driver Info", sortable: true, view: ["Pending - Commercial", "Pending - UW", "Active", "All Insurances"], preferenceSettings: { isVisible: true, canToggleVisibility: false, canReorder: false } },
    { id: "branch_id", name: "Branch", sortable: true, view: ["Pending - Commercial", "Pending - UW", "Active", "All Insurances"], preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "missing_docs", name: "Required Docs", sortable: false, view: ["Pending - Commercial", "Pending - UW"], preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "status", name: "Status", sortable: false, view: ["All Insurances"], preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "insurance_notes", name: "Insurance Notes", sortable: false, view: ["Pending - Commercial", "Pending - UW", "Active", "All Insurances"], preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "driver_notes", name: "Driver Notes", sortable: false, view: ["Pending - Commercial", "Pending - UW", "Active", "All Insurances"], preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "tags", name: "Tags", sortable: false, view: ["Pending - Commercial", "Pending - UW", "Active", "All Insurances"], preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
    { id: "assigned_to", name: "Assigned To", sortable: false, view: ["Pending - Commercial", "Pending - UW", "Active", "All Insurances"], preferenceSettings: { isVisible: true, canToggleVisibility: true, canReorder: true } },
]

const getDefaultColumnConfig = () =>
    tableHeaders.map((column, index) => ({
        ...column,
        order: index,
    }))

class InsuranceListContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            filterValues: { ...INSURANCE_LISTING_TABS.find(tab => tab.id === props.activeTabId).filters },
            selectedInsurances: [],
            refetchInsurances: false,
            columnConfig: getDefaultColumnConfig(),
        }
    }

    setColumnConfig = (columnConfig) => {
        this.setState({ columnConfig })
    }

    applyTab = (tabId) => {
        this.setState({ filterValues: { ...INSURANCE_LISTING_TABS.find(tab => tab.id === tabId).filters } })
    }

    componentDidUpdate(prevProps) {
        // The tab follows the URL: tab clicks, sidebar links and Back/Forward all land here.
        if (prevProps.activeTabId !== this.props.activeTabId) this.applyTab(this.props.activeTabId)
    }

    updateOrder = (string) => {
        let order = [...this.state.filterValues.orderBy]
        if (!order.includes(string) && !order.includes("-" + string)) {
            order = [order.find(item => item.includes("-driver__in_office")), string]
        } else {
            let index = order.indexOf(string)
            if (order.indexOf(string) > -1) {
                order[index] = "-" + string
            } else {
                index = order.indexOf("-" + string)
                index > -1 && (order[index] = string)
            }
        }
        this.setState({ filterValues: { ...this.state.filterValues, orderBy: order } })
    }

    render() {
        const activeTab = INSURANCE_LISTING_TABS.find(tab => tab.id === this.props.activeTabId)
        return (
            <Container fluid className="bos-listing-container">
                <ListingTabs
                    tabs={INSURANCE_LISTING_TABS}
                    activeTab={this.props.activeTabId}
                    onChange={this.props.changeTab}
                />
                {activeTab.name !== "Activity Log" && <InsuranceListHeader
                    activeTab={activeTab.name}
                    filterValues={this.state.filterValues}
                    setFilterValues={(filterValues) => this.setState({ filterValues })}
                    selectedInsurances={this.state.selectedInsurances}
                    resetSelectedInsurances={() => this.setState({ selectedInsurances: [] })}
                    defaultFilters={activeTab.filters}
                    currentUser={this.props.currentUser}
                    location={this.props.location}
                    history={this.props.navigate}
                    refetchQuery={() => this.setState({ refetchInsurances: !this.state.refetchInsurances })}
                    columnConfig={this.state.columnConfig}
                    setColumnConfig={this.setColumnConfig}
                    tableId="insurance"
                    defaultColumnConfig={getDefaultColumnConfig()}
                />}
                {activeTab.name === "Activity Log" ?
                    <ReportsPanel reportId="insurance" />
                    :
                    <InsuranceList
                        selectedTab={activeTab.name}
                        key={String(this.state.refetchInsurances)}
                        columnConfig={this.state.columnConfig && this.state.columnConfig.filter(column => column.view.includes(activeTab.name))}
                        searchTerm={this.state.filterValues?.searchTerm ? this.state.filterValues.searchTerm : null}
                        hasMissingDocs={this.state.filterValues?.hasMissingDocs !== null ? this.state.filterValues.hasMissingDocs : null}
                        hasRental={this.state.filterValues?.hasRental !== null ? this.state.filterValues.hasRental : null}
                        inOffice={this.state.filterValues?.inOffice !== null ? this.state.filterValues.inOffice : null}
                        assignedTo={this.state.filterValues?.assignedTo ? this.state.filterValues.assignedTo : null}
                        driverStages={this.state.filterValues?.driverStages ? this.state.filterValues.driverStages : null}
                        driverTags={this.state.filterValues?.driverTags ? this.state.filterValues.driverTags : null}
                        orderBy={this.state.filterValues?.orderBy ? this.state.filterValues.orderBy : ["-id"]}
                        updateOrder={this.updateOrder}
                        statuses={this.state.filterValues?.statuses !== null ? (Array.isArray(this.state.filterValues.statuses) ? this.state.filterValues.statuses : this.state.filterValues.statuses ? [this.state.filterValues.statuses] : null) : null}
                        types={this.state.filterValues?.types !== null ? this.state.filterValues.types : null}
                        selectedInsurances={this.state.selectedInsurances}
                        currentUser={this.props.currentUser}
                        setSelectedInsurances={(selectedInsurances) => this.setState({ selectedInsurances })}
                        branchIds={this.state.filterValues?.selectedBranches !== null ? this.state.filterValues.selectedBranches : null}
                    />}
            </Container>

        )
    }
}


export default withPathTab(ROUTES.insurances)(withApolloClient(InsuranceListContainer));
